import { useCallback } from 'react';
import { SettingsInputProps } from './SettingsInputProps';
import NumberInput from '../../NumberInput/NumberInput';

export const NumberSettingsInput = (props: SettingsInputProps) => {
  const value = props.decimal
    ? props.value?.decimalValue
    : props.value?.intValue;

  const onChange = useCallback(
    (newValue: number) =>
      props.onChange(
        props.decimal ? { decimalValue: newValue } : { intValue: newValue },
      ),
    [props.decimal, props.onChange],
  );

  const errorMessages: string[] = [];
  if (
    Number.isFinite(props.minValue) &&
    (!Number.isFinite(value) || value! < props.minValue!)
  ) {
    errorMessages.push(`Minimum değer: ${props.minValue}`);
  } else if (
    Number.isFinite(props.maxValue) &&
    (!Number.isFinite(value) || value! > props.maxValue!)
  ) {
    errorMessages.push(`Maximum değer: ${props.maxValue}`);
  }

  return (
    <NumberInput
      value={value}
      onChange={onChange}
      acceptFloat={props.decimal}
      error={errorMessages.length > 0}
      helperText={
        errorMessages.length > 0 ? errorMessages.join(', ') : undefined
      }
      endAdornment={props.endAdornment ?? undefined}
    />
  );
};
